// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown-portal_dropdown__DeUZq","dropdownItem":"dropdown-portal_dropdownItem__EQGxR"};